var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer pl-4",class:_vm.classes},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://canhbaosom.com ","target":"_blank","rel":"nofollow"}},[_vm._v(" CBS")])])])}
var staticRenderFns = []

export { render, staticRenderFns }